export const defaultOrgType: AvailableOrgTypes = 'secondary';
export const defaultLocale = 'en-GB';
export type AvailableOrgTypes = 'secondary' | 'business' | 'bpp' | 'primary' | 'pearson' | 'ib';
